/**
 * SectionSwitcher - singleton class, which allows switch between different tables
 * on the page. You can see example on the page /jobs-flow
 */

import { CRUDFabric } from "../CRUDs/CRUDFabric.js";
import { Customer } from "../CRUDs/entities/Customer";
import { Invoice } from "../CRUDs/entities/Invoice.js";
import { JobRequest } from "../CRUDs/entities/JobRequest";
import { Quote } from "../CRUDs/entities/Quote.js";
import { Vehicle } from "../CRUDs/entities/Vehicle.js";
import { removeQueryParams, setQueryParams } from "./Filter";
import { Section } from "./Section";

export const SectionSwitcher = (() => {

    let instance = null;
    let sectionsList = [];

    const initSectionList = () => {
        $('.section').toArray().map((section) => {
            const classList = section.classList.value.trim().split(/\s+/);
            let sectionTitle = classList.pop();
            if (sectionTitle == 'selected') {
                sectionTitle = classList.pop();
            }
            sectionsList.push(new Section(sectionTitle));
        });
    }

    const getSelectedSectionTitle = () => {
        if($('.section.selected').length){
            const classList = $('.section.selected')[0].classList.value.trim().split(/\s+/);
            classList.pop();
            let section = classList.pop();
            return section;
        }
        return null
    }

    const showCreateLinksForSelectedSection = (section) => {
        $('.modal-window-actions').removeClass('d-flex');
        $('.modal-window-actions').addClass('d-none');
        const link = $('.action.custom-action').off();
        const linkHeader = $('.action.custom-action.header-action').off();
        let callback
        switch (section) {
            case 'jobs':
            case 'visits':
            case 'requests': case 'jobs':
                link.text(`Create new Request`)
                    .attr('data-action', 'create')
                    .removeAttr('data-class');
                linkHeader.text(`+ New request`)
                callback = (e) => {
                    const staticRequest = new JobRequest();
                    staticRequest.openModal('create');
                }
                break;
            case 'customers':
                link.text(`New Customer`)
                    .attr('data-action', 'create')
                    .attr('data-class', 'customer');
                linkHeader.text(`+ New customer`)
                callback = (e) => {
                    const staticCustomer = new Customer();
                    staticCustomer.openModal('create');
                }
                break;
            case 'vehicles':
                link.text('Create New Vehicle').attr('data-action', 'create').removeAttr('data-class');
                linkHeader.text(`+ New Vehicle`)
                callback= ()=>{
                    const vehicle = new Vehicle()
                    vehicle.openModal('create')
                }
                break;
            case 'invoices':
                link.text('Add an Invoice')
                    .removeAttr('data-class')
                    .removeAttr('data-action');
                linkHeader.text(`+ Add invoice`)
                callback = () => {
                    const invoice = new Invoice()
                    invoice.openModal('confirm-action');
                    //window.open('/jobs-flow/invoice/create', '_blank')
                }
                break;
            case 'quotes':
                link.text('Add Quote')
                    .removeAttr('data-class')
                    .removeAttr('data-action');
                linkHeader.text(`+ Add Quote`)
                callback = () => {
                    const quote = new Quote()
                    quote.openModal('confirm-action');
                    //window.open('/jobs-flow/quote/create', '_blank')
                }
                break;
            default:
                callback = function() {
                    const entityClass = this.getAttribute('data-class') ?? section;
                    const entity = CRUDFabric.getObject(entityClass);
                    entity.openModal(link.data('action'));
                }
                break;
        }
        if(typeof callback === 'function'){
            link.off('click').on('click', callback);
            linkHeader.off('click').on('click', callback)
        }
    }

    return class SectionSwitcher {
        constructor() {
            if (instance === null) {
                instance = this;
                this.init();
            }
            return instance;
        }
        init() {
            initSectionList();
            if (sectionsList.length>0) {
                this.showSelectedSection();
                this.sectionSwitcherListners();
            }
        }

        /**
         * return selected section
         *
         * @returns Section
         */
        getSelectedSection = (sectionTitle=null) => {
            getSelectedSectionTitle();
            for (let section of sectionsList) {
                if (!section.container.hasClass('d-none')) return section;
            }
        }

        hideAll() {
            sectionsList.forEach((section) => {
                section.hide();
            });

            return this;
        }

        /**
         * Show section with attribute "selected" or with given section name
         *
         * @param { string|null } section
         */

        showSelectedSection(sectionTitle=null) {

            const selectedSectionTitle = sectionTitle ?? getSelectedSectionTitle();
            if(selectedSectionTitle){
                const section = SectionSwitcher.getSectionByTitle(selectedSectionTitle);

                $(`.data-view.${selectedSectionTitle}`).removeClass('d-none');
                $(`.data-view.${selectedSectionTitle}`).addClass('d-block');

                $(`.data-view.${selectedSectionTitle}`).find('.data-row').removeClass('d-none');

                let parentSection = $(`.sections .section.${selectedSectionTitle}`).data('parent-section')

                $(`.sections .section`).removeClass('selected');
                $(`.sections .section.${selectedSectionTitle}`).addClass('selected');
                if(parentSection){
                    $(`#${parentSection}`).addClass('selected');
                }

                if (['jobs','requests','visits','invoices','quotes'].includes(selectedSectionTitle)) {
                    $('.sub-sections').removeClass('d-none');
                } else if (selectedSectionTitle == 'orders' || selectedSectionTitle == 'paymethods') {
                    $('.sub-sections').addClass('d-none');
                }

                this.hideAll();
                section.show();

                showCreateLinksForSelectedSection(selectedSectionTitle);
                $('.modal-window-actions').css('display', 'none');

                if (selectedSectionTitle === "jobs_top") $(".section.jobs").trigger('click')
                document.dispatchEvent(new CustomEvent('show_section',{detail:{switcher:this, selected:selectedSectionTitle}}))
                return this.getSelectedSection();
            }
        }

        choseSection(clickElement){
            $('.section').removeClass('selected');
            if ($(clickElement).hasClass('section')) {
                $(clickElement).addClass('selected');
                removeQueryParams();
                setQueryParams({'entity_class': getSelectedSectionTitle()});
            } else {
                let elem = $(clickElement).closest('.section')[0];
                $(elem).addClass('selected');
            }
        }

        sectionSwitcherListners = () => {
            $('.section').off();
            $('.section').on('click', (e) => {
                this.choseSection(e.currentTarget);
                this.showSelectedSection();
            });
        }

        static getSectionByTitle = (title) => {
            for (let section of sectionsList)
                if (section.title == title) return section;

        }

        static start() {
            const switcher = new SectionSwitcher();

            $('.data-tables').css('display', 'flex');
            $('.wrapper-view').css({'padding': '15px 0 0 0', 'height': 'unset'});
            setTimeout(() => {
                const preloader = document.querySelector('.preloader')
                if(preloader)
                    preloader.style.display = 'none'
            }, 500);

            return switcher;
        }

        static updateSection(sectionTitle) {
            const section = SectionSwitcher.getSectionByTitle(sectionTitle);
            section.update();
        }
    }
})();
